import { useEffect, useState } from "react";

/**
 * Reactive viewport-width breakpoint hook. Keeps layout decisions in sync as
 * the user resizes the window (sidebar auto-collapse, etc). Returns `false`
 * until the first client render so SSR/hydration is stable.
 */
export function useBreakpoint(minWidthPx: number): boolean {
  const [matches, setMatches] = useState<boolean>(false);

  useEffect(() => {
    const mql = window.matchMedia(`(min-width: ${minWidthPx}px)`);
    const update = (): void => setMatches(mql.matches);
    update();
    mql.addEventListener("change", update);
    return () => mql.removeEventListener("change", update);
  }, [minWidthPx]);

  return matches;
}

/** True on xl+ (>= 1280px). Used to auto-collapse the sidebar on laptops/tablets. */
export function useIsWideScreen(): boolean {
  return useBreakpoint(1280);
}
